"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("../coreProduct/index"));
var _index2 = _interopRequireDefault(require("@/views/leaseStore/config/index.vue"));
var leaseApi = _interopRequireWildcard(require("@/api/leaseApi.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LeaseProductList',
  components: {
    storeIndex: _index.default,
    leaseConfig: _index2.default
  },
  data: function data() {
    return {
      leaseConfigDialogVisible: false,
      currentLeaseData: {},
      leaseConfig: {
        maxLeaseDuration: null,
        paymentMethod: null,
        leaseRules: '' // 初始值设为空字符串
      }
    };
  },
  created: function created() {
    this.fetchLeaseConfig();
  },
  methods: {
    fetchLeaseConfig: function fetchLeaseConfig() {
      var _this = this;
      leaseApi.getLeaseConfig({
        productId: this.$route.params.id
      }).then(function (res) {
        if (res) {
          // 强制转换leaseRules为字符串
          _this.leaseConfig = _objectSpread(_objectSpread({}, res), {}, {
            leaseRules: (res.leaseRules || '').toString()
          });
          _this.currentLeaseData = _objectSpread({}, _this.leaseConfig);
        }
      }).catch(function (err) {
        console.error('获取租赁配置失败：', err);
        _this.$message.warning('暂无租赁配置数据，可点击配置按钮新增');
      });
    },
    openLeaseConfigDialog: function openLeaseConfigDialog() {
      var _this2 = this;
      this.currentLeaseData = {};
      this.$nextTick(function () {
        // 赋值时确保leaseRules是字符串
        _this2.currentLeaseData = _objectSpread(_objectSpread({}, _this2.leaseConfig), {}, {
          leaseRules: (_this2.leaseConfig.leaseRules || '').toString()
        });
        _this2.leaseConfigDialogVisible = true;
      });
    },
    handleDialogClose: function handleDialogClose() {
      // 重置时强制leaseRules为空字符串
      this.currentLeaseData = {
        maxLeaseDuration: null,
        paymentMethod: null,
        leaseRules: '' // 关键：不能是null/undefined
      };
      this.leaseConfigDialogVisible = false;
    }
  }
};